import { render } from "./DbaTypeSelector.vue?vue&type=template&id=24036880"
import script from "./DbaTypeSelector.vue?vue&type=script&lang=js"
export * from "./DbaTypeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__